import myCrypto from '../../libs/MyCrypto.lib'
import myTools from '../../libs/MyTools.lib'

const state = {
  delayTime: process.env.NODE_ENV === 'development' ? 250 : 0,
  isUpdating: false,
  isUpdating2: false,
  isUpdating3: false,

  myToken: sessionStorage.getItem('myToken')
    ? sessionStorage.getItem('myToken')
    : null,

  // #region System
  appStyle: {
    'background-image': '',
    'background-repeat': 'repeat',
    'background-attachment': 'fixed'
  },
  system: {
    bg_image: '',
    dl_file: '',
    br_count: 0,
    dl_count: 0
  },
  // #endregion
  // #region Components
  components: {
    list: [],
    brand: [],
    series: [],
    detail: []
  },
  // #endregion
  // #region Board
  boards: [],
  // #endregion
  // #region Quote
  carts: [],
  cartsIdxs: [],
  submitQuoteResult: { res: null, err: null },
  // #endregion
  // #region Contact
  quoteContact: {
    name: '',
    phone: '',
    line: '',
    material: '',
    memo: ''
  },
  // #endregion
  // #region Error
  errorMessage: '',
  errorMessageList: {
    '1x009': '發生錯誤, 帳號重複登入,\n請重新登入.'
  },
  // #endregion
  // #region Feature
  features: [],
  // #endregion
  // #region
  // #endregion
  nothing: undefined
}

const getters = {
  getFeatureEnb: state => name => {
    if (!name) return false
    return state.features.indexOf(name) > -1 ? true : false
  }
}

const mutations = {
  // #region Home
  setBackgroundImage(state) {
    const image = sessionStorage.getItem('bg_image') || ''
    if (image) {
      state.appStyle['background-image'] =
        process.env.NODE_ENV === 'development'
          ? `url(http://localhost/p221001/public/images/${image})`
          : `url(images/${image})`
    }
  },
  setGetFeature(state) {
    state.isUpdating = false
  },
  updateFeature(state, d) {
    if (d.feature) state.features = d.feature || []
    state.isUpdating = true
  },
  // #endregion

  // #region Page1
  setUpdate(state) {
    state.isUpdating = true
    // #region System
    state.system = {
      bg_image: '',
      dl_file: '',
      br_count: 0,
      dl_count: 0
    }
    // #endregion

    // #region Components
    state.components.list = []
    state.components.brand = []
    state.components.series = []
    // #endregion

    // #region Board
    state.boards = []
    // #endregion

    // #region
    // #endregion
  },
  update(state, d) {
    state.isUpdating = false

    if (d.token) {
      state.myToken = d.token
      sessionStorage.setItem('myToken', d.token)
    }
    // #region System
    if (d.system) {
      state.system = {
        bg_image: d.system.bg_image || '',
        dl_file: d.system.dl_file || '',
        br_count: d.system.br_count || 0,
        dl_count: d.system.dl_count || 0
      }
      // state.appStyle['background-image'] = `url(${state.system.bg_image})`
      sessionStorage.setItem('bg_image', state.system.bg_image)
      // if (state.appStyle['background-image'] === '') {
      //   const image = state.system.bg_image || ''
      //   process.env.NODE_ENV === 'development'
      //     ? `url(http://localhost/p221001/public/images/${image})`
      //     : `url(images/${image})`
      // }
    }
    // #endregion

    // #region Components
    if (d.components) {
      state.components = {
        list: d.components.list || [],
        brand: d.components.brand || [],
        series: d.components.series || []
      }
    }
    // #endregion

    // #region Board
    if (d.board) state.boards = d.board
    // #endregion
  },
  // #endregion

  // #region Page2
  setUpdateHome2(state) {
    state.isUpdating2 = true
    state.components.brand = []
    state.components.series = []
    state.components.detail = []
  },
  updateHome2(state, d) {
    state.isUpdating2 = false

    if (d.token) {
      state.myToken = d.token
      sessionStorage.setItem('myToken', d.token)
    }

    // #region System
    if (d.system) {
      state.system = {
        bg_image: d.system.bg_image || '',
        dl_file: d.system.dl_file || '',
        br_count: d.system.br_count || 0,
        dl_count: d.system.dl_count || 0
      }
      sessionStorage.setItem('bg_image', state.system.bg_image)
      // if (state.appStyle['background-image'] === '') {
      //   const image = state.system.bg_image || ''
      //   process.env.NODE_ENV === 'development'
      //     ? `url(http://localhost/p221001/public/images/${image})`
      //     : `url(images/${image})`
      // }
    }
    // #endregion

    // #region Components
    if (d.components) {
      state.components.list = d.components.list || []
      state.components.brand = d.components.brand || []
      state.components.series = d.components.series || []
      state.components.detail = d.components.detail || []
    }
    // #endregion
  },
  // #endregion

  // #region Page3
  addToCarts(state, d) {
    state.carts.push(d)
    if (!state.cartsIdxs[d.l_id]) state.cartsIdxs[d.l_id] = []
    state.cartsIdxs[d.l_id][d.idx] = true
  },
  removeFromCarts(state, idx) {
    const d = state.carts[idx]
    state.cartsIdxs[d.l_id][d.idx] = undefined
    state.carts.splice(idx, 1)
  },
  setUpdatePage3(state) {
    state.isUpdating3 = true
  },
  updatePage3(state, d) {
    if (d.contact) {
      state.quoteContact.name = d.contact.name || ''
      state.quoteContact.phone = d.contact.phone || ''
      state.quoteContact.line = d.contact.line || ''
      state.quoteContact.material = d.contact.material || ''
      state.quoteContact.memo = d.contact.memo || ''
    }
    if (d.token) {
      state.myToken = d.token
      sessionStorage.setItem('myToken', d.token)
    }
    if (d.res) state.submitQuoteResult.res = d.res
    if (d.err) state.submitQuoteResult.err = d.err
    state.isUpdating3 = false
  },
  clearCarts(state) {
    state.carts = []
    state.cartsIdxs = []
  },
  // #endregion

  // #region Error
  updateErrorMsg(state, err) {
    state.errorMessage = state.errorMessageList[err]
  },
  clearErrorMsg(state) {
    state.errorMessage = ''
  },
  // #endregion

  // #region
  // #endregion
  nothing() {}
}

const actions = {
  // #region Home
  getFeature({ state, commit, dispatch }) {
    commit('setGetFeature')
    return dispatch(
      'sendRequest',
      {
        params: [{ key: 'request', value: 'feature' }]
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateFeature', decryptdata)
    })
  },
  // #endregion

  // #region Page1
  getHome({ commit, dispatch }, { user, uid }) {
    commit('setUpdate')
    return dispatch(
      'sendRequest',
      {
        params: [
          { key: 'request', value: 'home' },
          { key: 'token', value: state.myToken },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ]
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('update', decryptdata)
    })
  },
  // eslint-disable-next-line no-unused-vars
  updateDownloadCount({ dispatch }, { user, uid }) {
    return dispatch(
      'sendRequest',
      {
        params: [
          { key: 'request', value: 'updatedlc' },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ]
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return
    })
  },
  // #endregion

  // #region Page2
  // eslint-disable-next-line prettier/prettier
  getComponentsByOption({ state, commit, dispatch }, { l_id, g_id, user, uid }) {
    commit('setUpdateHome2')
    return dispatch(
      'sendRequest',
      {
        params: [
          { key: 'request', value: 'home2' },
          { key: 'l_id', value: l_id },
          { key: 'g_id', value: g_id },
          { key: 'token', value: state.myToken },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ]
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) {
        commit('updateErrorMsg', err)
        setTimeout(() => commit('clearErrorMsg'), 10000)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updateHome2', decryptdata)
    })
  },
  // #endregion

  // #region Page3
  // eslint-disable-next-line no-unused-vars
  getContact({ state, commit, dispatch }, { user_id, tag, user, uid }) {
    commit('setUpdatePage3')
    return dispatch(
      'sendRequest',
      {
        params: [
          { key: 'request', value: 'home3' },
          { key: 'user_id', value: user_id },
          { key: 'tag', value: tag },
          { key: 'token', value: state.myToken },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ]
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) return

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updatePage3', decryptdata)
    })
  },
  // eslint-disable-next-line no-unused-vars
  submitQuote({ state, commit, dispatch }, { quote, quoteList, user, uid }) {
    commit('setUpdatePage3')
    return dispatch(
      'sendRequest',
      {
        params: [
          { key: 'request', value: 'submit' },
          { key: 'quote', value: quote },
          { key: 'quote_list', value: quoteList },
          { key: 'user', value: user },
          { key: 'uid', value: uid }
        ]
      },
      { root: true }
    ).then(async res => {
      const err = res.data.err || false
      if (err) {
        commit('updateErrorMsg', err)
        setTimeout(() => commit('clearErrorMsg'), 10000)
        return
      }

      const decryptstr = myCrypto.Decrypto(res.data)
      if (!decryptstr) return

      const decryptdata = myTools.convert2JOSN(decryptstr)
      if (!decryptdata) return
      // Delay
      await new Promise(r => setTimeout(r, state.delayTime))
      commit('updatePage3', decryptdata)
    })
  }
  // #endregion

  // #region
  // #endregion
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
